import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";
import { getAnnuityFactor } from "web_myplann/Shared/Utils/getAnnuityFactor";

export const calcRentPresentValue = (
	monthly: number,
	months: number,
): number => {
	if (monthly <= 0 || months <= 0) return 0;
	return monthly * getAnnuityFactor(GOAL_REAL_YIELD / 12, months);
};
